import { useState } from 'react';
import { IUser } from 'types';
import useModal from 'hooks/useModal';
import { UserQuery } from 'queries';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

interface Props {
  user: IUser;
}

function useUserMemo({ user }: Props) {
  const { handleAlert } = useModal();
  const { mutate } = UserQuery.usePut();
  const [isOpenUserMemo, setIsOpenUserMemo] = useState(false);

  const handleSave = ({ memo }: { memo: string }) => {
    mutate(
      { id: user.id, memo },
      {
        onSettled: () => setIsOpenUserMemo(false),
        onSuccess: () => toast.success('메모가 저장되었습니다.'),
        onError: () => handleAlert(DEFAULT_ERROR_MESSAGE),
      },
    );
  };

  return { isOpenUserMemo, setIsOpenUserMemo, handleSave };
}

export default useUserMemo;
